import * as React from 'react'
import { ReactElement, ReactNode } from 'react'
import {
  List,
  MenuItem,
  ListItemIcon,
  Typography,
  Collapse,
  Tooltip,
} from '@mui/material'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { useSidebarState } from './useSidebarState'
import { MenuItemLinkClasses } from './MenuItemLink'
interface Props {
  dense: boolean
  handleToggle: () => void
  icon: ReactElement
  isOpen: boolean
  name: string
  children: ReactNode
}

const SubMenu = (props: Props) => {
  const { handleToggle, isOpen, name, icon, children, dense } = props
  //const translate = useTranslate()

  const [sidebarIsOpen] = useSidebarState()

  const header = (
    <MenuItem dense={dense} onClick={handleToggle}>
      <ListItemIcon
        sx={{ marginRight: 0.5 }}
        className={MenuItemLinkClasses.icon}
      >
        {isOpen ? <ExpandMore /> : icon}
      </ListItemIcon>
      <Typography variant="inherit" color="textSecondary">
        {name}
      </Typography>
    </MenuItem>
  )

  return (
    <div>
      {sidebarIsOpen || isOpen ? (
        header
      ) : (
        <Tooltip title={name} placement="right">
          {header}
        </Tooltip>
      )}
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List
          dense={dense}
          component="div"
          disablePadding
          sx={{
            '& a': {
              transition: 'padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
              paddingLeft: sidebarIsOpen ? 4 : 2,
            },
          }}
        >
          {children}
        </List>
      </Collapse>
    </div>
  )
}

export default SubMenu
